<template>
<section v-scroll="handleScroll">
  <cham-block animation-class="slideInDown">
    <cham-header main-title="Chamara Abeysekara ;" subtitle="Developer • Designer • Freelancer • Entrepreneur • Content Maker"/>
    <cham-main-image animation-class="slideInUp"/>

    <cham-socail/>

    <cham-stripes/>

    <section class="section">
      <div class="columns">
        <div class="column">
          <cham-about-me/>
        </div>
        <div class="column is-hidden-mobile">
          <cham-side-image/>
        </div>
      </div>
    </section>

    <Skills :scrolling="scorllData" />
  </cham-block>
</section>
</template>

<script>
import 'nprogress/nprogress.css';
import NProgress from 'nprogress';
import Skills from '../Skills';

export default {
  components : {
    Skills
  },
  data : () => ({
      scorllData : {}
  }),
  name: 'Home',
  mounted (){
    document.title = "Chamara Abeysekara"
    NProgress.start()
    NProgress.set(0.9)
    NProgress.done()
  },
  methods: {
    handleScroll (evt, el) {
        this.scorllData = {evt , el}
    }
  },
  metaInfo: {
    // Children can override the title.
    title: 'Chamara Abeysekara',
    meta: [
      {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {name: 'description', content: 'Chamara Abeysekara - Web Developer.'}
    ]
  }
}
</script>

<style lang="scss">
@import '../../../static/styles.scss';




</style>



// WEBPACK FOOTER //
// src/componests/pages/Home.vue